import React from 'react';
import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import cn from '../utils/cn';
import styles from './Card.module.css';

const card = cva(styles.root, {
  variants: {
    variant: { product: styles.product, surface: styles.surface },
    interactive: { true: styles.interactive },
    shape: { sharp: styles.sharp }
  },
  defaultVariants: { variant: 'product', interactive: false }
});

const Card = React.forwardRef(function Card(
  {
    variant,
    interactive,
    shape,
    as: Tag = 'div',
    className,
    children,
    ...rest
  },
  ref
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        card({ variant, interactive: interactive ? 'true' : undefined, shape }),
        className
      )}
      {...rest}>
      {shape === 'sharp' ? (
        <div className={styles.sharpContent}>{children}</div>
      ) : (
        children
      )}
    </Tag>
  );
});

Card.propTypes = {
  variant: PropTypes.oneOf(['product', 'surface']),
  interactive: PropTypes.bool,
  shape: PropTypes.oneOf(['sharp']),
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Card;
